import styled, { css } from 'styled-components';
import { renderTextVariations } from '../utils/renderTextVariations.js';

const DetailedSubheading = styled.h4(({ type = 'default', bold, theme: { olist: { components: { text: { detailedSubheading }, }, }, }, }) => css `
      ${renderTextVariations(detailedSubheading, type, bold)}
    `);

export { DetailedSubheading as default };
